import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import bgTrusted from "../../assets/bgimg1.png";
import sealTrusted from "../../assets/trustedseal.png";
import img1 from "../../assets/award1.png";
import img2 from "../../assets/award2.png";
import img3 from "../../assets/award3.png";
import img4 from "../../assets/award4.png";
import img5 from "../../assets/award5.png";
import img6 from "../../assets/award6.png";
import img7 from "../../assets/award7.png";
import img8 from "../../assets/award8.png";

const awardsData = [
  { title: "Client Excellence Partner Award", year: "Awarded by: Indian Achievers Forum and CSR Times", description: "Recognized for outstanding recruitment support and talent alignment during their 2022 expansion.", image: img1 },
  { title: "Top 10 Promising HR Consultants – South India", year: "Featured by: Startup Success Digest (2024 Edition)", description: "Listed among South India's most dynamic HR solution providers for your unique blend of strategy + psychology.", image: img2 },
  { title: "Butterfly Impact Award (Internal Annual Recognition)", year: "Awarded to: The Butterfly Team", description: "Celebrating team members who’ve gone above and beyond to create transformation in client organizations.", image: img3 },
  { title: "Zoho Affiliate Partner – Excellence Badge", year: "By: Zoho Partner Network", description: "For seamless deployment of Zoho Recruit, Forms, and CRM to HR clients in Tamil Nadu and beyond.", image: img4 },
  { title: "Career Catalyst Award – 2023", year: "Event: University Hiring Summit (Coimbatore Region)", description: "Honored for empowering over 500+ college students through placement training & resume coaching.", image: img5 },
  { title: "Women-led HR Enterprise of the Year – Shortlisted", year: "By: Rotary Women in Business Forum", description: "Recognized as a powerful woman-led consultancy transforming careers with compassion and clarity.", image: img6 },
  { title: "100+ Clients Served Milestone – 2025", year: "", description: "Achieved a client base of over 100 trusted partners in less than 3 years through word-of-mouth and organic trust.", image: img7 },
  { title: "Emotional Intelligence in HR Recognition", year: "By: Indian Psychologists Network (IPN)", description: "Honored for integrating psychology into HR practices to promote mindful hiring and team building.", image: img8 },
];

const AwardsPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div>
      {/* Awards Section */}
      <section  data-aos="fade-up" className="w-full px-4 sm:px-6 md:px-12 py-8 sm:py-12">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-2xl sm:text-3xl md:text-[40px] font-bold text-[#172633] mb-6 sm:mb-8 uppercase">
            Butterfly Milestones <br/>Awards & Achievements
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {awardsData.map((award, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-lg transition"
              >
                <img
                  src={award.image}
                  alt={award.title}
                  className="w-full h-32 sm:h-40 object-cover"
                />
                <div className="p-3 sm:p-5 text-left">
                  <h3 className="text-sm sm:text-lg font-semibold text-gray-800">
                    {award.title}
                  </h3>
                  {award.year && (
                    <span className="text-xs sm:text-sm text-[#204356] mt-1 block">
                      {award.year}
                    </span>
                  )}
                  <p className="text-xs sm:text-sm text-[#204356] mt-2">{award.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trusted Section */}
      <section  data-aos="fade-up"  className="relative w-full py-8 sm:py-20 px-4 sm:px-6 md:px-12 bg-[#005CA8] mt-16 text-white">
        <div
          className="absolute inset-0 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgTrusted})` }}
        ></div>

        <div className="absolute -top-12 sm:-top-16 left-1/2 transform -translate-x-1/2 z-20">
          <img
            src={sealTrusted}
            alt="Trusted Seal"
            className="w-24 sm:w-32 md:w-40"
          />
        </div>

        <div className="relative z-10 max-w-3xl sm:max-w-5xl mx-auto flex flex-col items-center text-center mt-16">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4">
            TRUSTED BY CLIENTS
          </h2>
          <p className="text-lg sm:text-xl font-semibold mb-2">
            <span className="text-yellow-300">4.9★</span> average client feedback across platforms.
          </p>

        </div>
      </section>
    </div>
  );
};

export default AwardsPage;
